import { render, staticRenderFns } from "./SpotifyCard.vue?vue&type=template&id=6d008aea&scoped=true&"
import script from "./SpotifyCard.vue?vue&type=script&lang=js&"
export * from "./SpotifyCard.vue?vue&type=script&lang=js&"
import style0 from "./SpotifyCard.vue?vue&type=style&index=0&id=6d008aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d008aea",
  null
  
)

export default component.exports